import root from './_root.js';

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

export default coreJsData;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_coreJsData.js
// module id = 1286
// module chunks = 0